import { DEFAULT_AVT_IMG } from '@/constant/imgImport';

interface IEnterpriseUserList {
  avatarList: Array<string>;
}

const EnterpriseUserList = ({ avatarList }: IEnterpriseUserList) => {
  const length = avatarList.length - 1;

  return (
    <div
      className="relative flex items-center"
      style={{
        width: ((): string => {
          const widthPerAva = 20;

          return `${
            widthPerAva * (length + 1) - ((widthPerAva * 25) / 100) * length
          }px`;
        })(),
      }}
    >
      {avatarList.map((item, index) => (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          key={index}
          alt="avatar"
          loading="lazy"
          decoding="async"
          src={item || DEFAULT_AVT_IMG}
          className="aspect-square w-[20px] rounded-full"
          style={{
            transform: `translateX(-${index * 25}%)`,
            zIndex: `${length - index}`,
          }}
        />
      ))}
    </div>
  );
};

export default EnterpriseUserList;
